/* import __COLOCATED_TEMPLATE__ from './answer-event-log.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent-2 */

import Component from '@glimmer/component';
import { action } from '@ember/object';
import { type InterfaceIconName } from '@intercom/pulse/lib/interface-icons';
// @ts-expect-error
import { sanitizeHtml } from '@intercom/pulse/lib/sanitize';
import { type SafeString } from '@ember/template/-private/handlebars';

interface Signature {
  Args: {
    linkUrl?: string;
    linkText?: string;
    isDeleted: boolean;
    icon: InterfaceIconName;
    translationKey: string;
    type: string;
    spacing?: string;
    instrumentLinkClick?: () => void;
  };
  Element: HTMLDivElement;
  Blocks: {
    default: [];
  };
}

export default class AnswerEventLog extends Component<Signature> {
  get linkHtml(): SafeString {
    if (!this.args.linkUrl || !this.args.linkText) {
      return sanitizeHtml('');
    }

    return sanitizeHtml(
      `<span class="text"><a href="${this.args.linkUrl}" target="_blank" class="fin-playground__answer-notice__link fin_testing__instrumentation__link">${this.args.linkText}</a></span>`,
    );
  }

  @action
  instrumentLinkClick(evt: Event) {
    if (
      evt.target instanceof HTMLAnchorElement &&
      // This class is used to target only the specific <a> tag for click events.
      // We need this approach because: 1) clicking anywhere in the text would otherwise
      // trigger the event, and 2) sanitizeHtml removes custom attributes/event listeners
      // that would be needed for more idiomatic event handling.
      evt.target.classList.contains('fin_testing__instrumentation__link') &&
      this.args.instrumentLinkClick
    ) {
      this.args.instrumentLinkClick();
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::Playground::AnswerEventLog': typeof AnswerEventLog;
    'ai-agent/playground/answer-event-log': typeof AnswerEventLog;
  }
}
